import {axios} from "@/utils"

const endpoints = {
    get_digital_items: '/cart/digital-items/',
    create_digital_item: '/cart/digital-items/',
    add_medias_to_digital_item: '/cart/digital-items/{id}/add-medias/',
    add_all_medias_to_digital_item: '/cart/digital-items/add-all-medias/',
    remove_medias_from_digital_item: '/cart/digital-items/{id}/remove-medias/',
    set_digital_item_type: '/cart/digital-items/{id}/set-type/',
    remove_digital_item: '/cart/digital-items/{id}/',
    get_totals: '/cart/totals/',
    get_digital_items_totals: '/cart/totals/items/',
    get_payments: '/cart/payment-methods/',
    get_digital_item_medias: '/cart/digital-items/{id}/medias/',
    create_order: '/v3/orders/',
    get_order: '/v3/orders/{id}/',
    delete_cart: '/cart/',
}

export default {
    async getDigitalItems(params) {
        const response = await axios.get(endpoints.get_digital_items, {params})
        return response.data
    },
    async createDigitalItem(params) {
        const response = await axios.post(endpoints.create_digital_item, params)
        return response.data
    },
    async addMediasToDigitalItem(id, params) {
        const response = await axios.patch(endpoints.add_medias_to_digital_item.replace('{id}', id), params)
        return response.data
    },
    async addAllMediasToDigitalItem(params) {
        const response = await axios.post(endpoints.add_all_medias_to_digital_item, params)
        return response.data
    },
    async removeMediasFromDigitalItem(id, params) {
        const response = await axios.patch(endpoints.remove_medias_from_digital_item.replace('{id}', id), params)
        return response.data
    },
    async setDigitalItemType(id, params) {
        const response = await axios.patch(endpoints.set_digital_item_type.replace('{id}', id), params)
        return response.data
    },
    async removeDigitalItem(id) {
        const response = await axios.delete(endpoints.remove_digital_item.replace('{id}', id))
        return response.data
    },
    async getTotals(params) {
        const response = await axios.get(endpoints.get_totals, {params})
        return response.data
    },
    async getPayments(params) {
        const response = await axios.get(endpoints.get_payments, {params})
        return response.data
    },
    async getDigitalItemMedias(id, params) {
        const response = await axios.get(endpoints.get_digital_item_medias.replace('{id}', id), {params})
        return response.data
    },
    async getDigitalItemsTotals(params) {
        const response = await axios.get(endpoints.get_digital_items_totals, {params})
        return response.data
    },
    async createOrder(params) {
        const response = await axios.post(endpoints.create_order, params)
        return response.data
    },
    async getOrder(id) {
        const response = await axios.get(endpoints.get_order.replace('{id}', id))
        return response.data
    },
    async deleteCart() {
        const response = await axios.delete(endpoints.delete_cart)
        return response.data
    }
}